import styled from 'styled-components';
import { colors } from '../../styles/colors';

export const CHAT_PANEL_WIDTH = 400;

export const MobileFloatingButton = styled.button`
  display: none;

  @media (max-width: 810px) {
    display: flex;
    position: fixed;
    bottom: 24px;
    right: 24px;
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background-color: ${colors.brand.principal};
    border: none;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
    z-index: 1000;
    transition: background-color 0.2s;

    &:hover {
      background-color: ${colors.brand.principalHover};
      color: ${colors.White};
    }

    svg {
      color: ${colors.White};
      fill: ${colors.White};
    }
  }
`;

export const ChatPanel = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  height: 100dvh;
  width: ${CHAT_PANEL_WIDTH}px;
  background-color: ${colors.White};
  box-shadow: -4px 0 16px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 950;
  transform: translateX(${({ isOpen }) => (isOpen ? '0' : '100%')});
  transition: transform 0.25s ease;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ChatHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background-color: ${colors.brand.principal};
  color: ${colors.White};
  flex-shrink: 0;
`;

export const ChatHeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ChatTitle = styled.span`
  font-size: 16px;
  color: ${colors.White};
  letter-spacing: -0.01em;
`;

export const ChatTitleBold = styled.span`
  font-weight: 700;
`;

export const ChatTitleThin = styled.span`
  font-weight: 300;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  color: ${colors.White};
  opacity: 0.85;

  &:hover {
    opacity: 1;
  }
`;

export const MessageList = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const fadeSlideIn = `
  @keyframes fadeSlideIn {
    from {
      opacity: 0;
      transform: translateY(8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const UserMessageBubble = styled.div`
  max-width: 80%;
  padding: 10px 14px;
  border-radius: 12px 12px 2px;
  background-color: ${colors.Blue300};
  color: ${colors.White};
  font-size: 13px;
  line-height: 1.5;
  align-self: flex-end;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  animation: fadeSlideIn 0.3s ease-out;
  ${fadeSlideIn}
`;

export const AiMessage = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  align-self: flex-start;
  animation: fadeSlideIn 0.3s ease-out;
  ${fadeSlideIn}
`;

export const AiIconWrapper = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20.8px;
  color: ${colors.Blue300};
`;

export const AiMessageText = styled.div`
  flex: 1;
  font-size: 13px;
  line-height: 1.6;
  color: ${colors.Grey400};
  overflow-wrap: break-word;
  white-space: pre-wrap;
`;

export const InputArea = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid ${colors.Grey050};
  flex-shrink: 0;
`;

export const Disclaimer = styled.span`
  display: block;
  padding: 0 8px 12px;
  font-size: 10px;
  line-height: 1.4;
  color: ${colors.Grey200};
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 0;
`;

export const MessageInput = styled.input`
  flex: 1;
  border: 1px solid ${colors.GreyInputBorder};
  border-radius: 20px;
  padding: 8px 14px;
  font-size: 13px;
  outline: none;
  color: ${colors.Grey400};

  &:focus {
    border-color: ${colors.Blue300};
  }

  &::placeholder {
    color: ${colors.Grey200};
  }
`;

export const SendButton = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: ${colors.brand.principal};
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background-color 0.2s;

  &:hover:not(:disabled) {
    background-color: ${colors.brand.principalHover};
    color: ${colors.White};
  }

  &:disabled {
    background-color: ${colors.Grey200};
    cursor: not-allowed;
  }

  svg {
    color: ${colors.White};
    fill: ${colors.White};
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 8px 4px;
`;

export const EmptyGreeting = styled.h3`
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: ${colors.Grey400};
  margin: 8px 0 0;
`;

export const EmptyPrompt = styled.p`
  font-size: 13px;
  line-height: 1.5;
  color: ${colors.Grey200};
  margin: 0;
`;
